import mori from 'mori';

function getDataViews(headers, displayOrder) {
  // pluck dataviews from headers where applicable
  const foundDataviews = mori.toJs(mori.distinct(mori.map(
    (header) => mori.hashMap(
      'label', mori.get(header, 'label'),
      'type', mori.get(header, 'type')
    ), mori.rest(headers))));

  // sort the views that are listed in the display order
  const sorted = foundDataviews
    .filter((dataview) => displayOrder.indexOf(dataview.label) > -1)
    .sort((a, b) => {
      return displayOrder.indexOf(a.label) - displayOrder.indexOf(b.label);
    });

  // add any more views that don't have a specified display order
  return sorted.concat(foundDataviews.filter((dataview) => {
    return displayOrder.indexOf(dataview.label) === -1;
  }));
}

/**
 * A transducer that creates the dataview list
 *
 * @param {array} sheets - The headers array
 * @return {array} A list of available dataviews
 */
export default function(headers, config, headersAll) {
  // parse the display order
  const displayOrder = mori.getIn(
    config,
    ['settings', 'globalSettings', 'Display Order'],
    '')
    .split(',')
    .map((dataview) => dataview.trim());

  return {
    immutableDataviews: getDataViews(headers, displayOrder),
    immutableDataviewsAll: Object.keys(headersAll)
      .reduce((acc, curr) => ({
        [curr]: {
          immutableDataviews:
            getDataViews(headersAll[curr].immutableHeaders, displayOrder),
        },
        ...acc,
      }), {}),
  };
}



// WEBPACK FOOTER //
// ../datacenter/app/js/services/dataviewFilters.js